/* eslint-disable no-multi-spaces */

export default [
  1,    // Animals & Pet Supplies
  166,  // Apparel & Accessories
  8,    // Arts & Entertainment
  537,  // Baby & Toddler
  111,  // Business & Industrial
  141,  // Cameras & Optics
  222,  // Electronics
  412,  // Food, Beverages & Tobacco
  436,  // Furniture
  632,  // Hardware
  469,  // Health & Beauty
  536,  // Home & Garden
  5181, // Luggage & Bags
  772,  // Mature
  783,  // Media
  922,  // Office Supplies
  5605, // Religious & Ceremonial
  2092, // Software
  988,  // Sporting Goods
  1239, // Toys & Games
  888,  // Vehicles & Parts
];
